import React, { useEffect, useState } from "react";
import { CellProps } from "react-table";
import AgTableInfiniteScroll from "../../../components/AgTableV2InfiniteScroll";
import { TblInboxMessage } from "../../../models";
import { INQUIRY_CONSTANT, OFFERING_TYPE, OFFERING_TYPE_NAME } from "../../../utils/constant";
import {
  formatDateTimeNoSecond,
  formatDateTimeToLocalTime
} from "../../../utils/helper";
import CardMessageMobileTable from "../CardMessageMobileTable";
import { IMailTableProps } from "./mailTable.props";

const MailTableView: React.FC<IMailTableProps> = ({
  dataInbox,
  onOpenMessageDetail,
  isLoading,
  getInquiryDetails,
  onClickEdit,
  setDeletedInboxMessageId,
  updateInfoAction,
  onLoadMore,
  maxLength,
  data,
  isClickAddInquiry,
  isClickExportExcel,
  isClickFilterOnMobile,
  onCloseTrailItem,
  ...props
}: IMailTableProps) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobileScreen = screenWidth <= 768;
  const isLargeScreen = screenWidth >= 1024;

  const columns = React.useMemo(
    () => [
      {
        Header: "  ",
        width: `${isLargeScreen ? "29%" : "26%"}`,
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;
          return (
            <div className="flex flex-col items-start">
              <p className={`text-[14px] ${rowData.isReaded ? "" : "font-bold"} text-[#58585B]  m-0 p-0`}>
                {rowData.fkFromIndividual &&
                  `${rowData.fkFromIndividual?.firstName ?? ""} 
                    ${rowData.fkFromIndividual?.lastName ?? ""}`}
              </p>
              <p
                className={`text-[12px] ${rowData.isReaded ? "" : "font-bold"
                  } text-[#637381] m-0 p-0`}
              >
                {rowData.fkInquiryType?.inquiryTypeName ===
                  INQUIRY_CONSTANT.INQUIRY_TYPE_NAME.INSIDE
                  ? formatDateTimeNoSecond(formatDateTimeToLocalTime(rowData.sendDate))
                  : formatDateTimeNoSecond(
                    (() => {
                      const date = new Date(`${rowData?.sendDate}Z`);
                      date.setHours(0, 0, 0, 0);
                      return date;
                    })(),
                  )}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Subject",
        width: `${isLargeScreen ? "29%" : "26%"}`,
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;

          // return <p className={`block line-clamp-1 ${rowData.isReaded ? "" : "font-bold"} text-nowrap max-w-[200px] text-ellipsis overflow-hidden`}>{rowData.subject}</p>;
          return (
            <p
              className={`${rowData.isReaded ? "" : "font-bold"
                } block max-w-[200px] overflow-hidden text-ellipsis text-nowrap md:whitespace-normal md:line-clamp-1 md:overflow-hidden md:text-ellipsis md:-webkit-box md:-webkit-line-clamp-1 md:-webkit-box-orient-vertical`}
            >
              {rowData.subject}
            </p>
          );
        },
      },
      {
        Header: "Offering Type",
        width: "15%",
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;
          let comType =
          rowData.fkComOffering?.fkOfferingType?.offeringTypeName ??
          rowData?.fkInquiry?.fkMainService?.fkOfferingType?.offeringTypeName ??
          rowData?.fkInquiry?.otherNavigation?.offeringTypeName ?? "N/A";

          return comType ? (
            <p className={`${rowData.isReaded ? "" : "font-bold"}`}>{comType}</p>
          ) : null;
        },
      },
      {
        Header: "Status",
        width: "13%",
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;
          let inboxStatus = rowData.fkInquiryStatus?.status ?? "";

          return <p className={`${rowData.isReaded ? "" : "font-bold"}`}>{inboxStatus}</p>;
        },
      },
      {
        Header: " ",
        width: `${isLargeScreen ? "14%" : "20%"}`,
        Cell: ({ cell, row }: CellProps<TblInboxMessage, any>) => {
          const rowData = row.original;

          return (
            <div className="flex gap-4">
              <p
                style={{ color: "#0971A2" }}
                className="inline text-blue-700 hover:cursor-pointer font-bold"
                onClick={() => {
                  getInquiryDetails(rowData.inboxMessageId);
                  onClickEdit(rowData.inboxMessageId)
                }}
              >
                Edit
              </p>
              <p
                style={{ color: "#0971A2" }}
                className="inline text-blue-700 hover:cursor-pointer font-bold"
                onClick={() => {
                  setDeletedInboxMessageId(rowData.inboxMessageId!);
                }}
              >
                Delete
              </p>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onClickEdit, screenWidth],
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`${isMobileScreen ? "mt-[35px]" : ""} `}>
      {isMobileScreen ? (
        <CardMessageMobileTable
          loadMore={onLoadMore}
          data={data ?? []}
          maxLength={dataInbox.maxLength ?? 0}
          isClickOnRow={true}
          onClickOnRow={(e, cell) => onOpenMessageDetail(e, cell)}
          textNoDataFound="No inquiries received."
          isReceivedTab={true}
          isLoading={isLoading}
          onClickEdit={onClickEdit}
          getInquiryDetails={getInquiryDetails}
          setDeletedInboxMessageId={setDeletedInboxMessageId}
          updateInfoAction={updateInfoAction}
          isClickAddInquiry={isClickAddInquiry}
          isClickExportExcel={isClickExportExcel}
          isClickFilterOnMobile={isClickFilterOnMobile}
          onCloseTrailItem={onCloseTrailItem}
        />
      ) : (
        <AgTableInfiniteScroll
          columns={columns}
          noHeader={true}
          data={data ?? []}
          scrollableTarget="scrollableDiv"
          onLoadMoreData={onLoadMore}
          maxLength={dataInbox.maxLength ?? 0}
          isClickOnRow={true}
          onClickOnRow={(e, cell) => onOpenMessageDetail(e, cell)}
          textNoDataFound="No inquiries received."
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default React.memo(MailTableView);
